import { useState } from "react";
import { url } from "../utils/config";
import axios from "axios";
import AddResourceCharge from "../modals/AddResourceCharge";
import Table from "../reusable_components/Table";
import Button from "../reusable_components/Button";
import { btnGreen, btnRed, title } from "../utils/style";
import { toast } from "react-toastify";
import edit from '../assets/icons/edit.png'
import deleteIcon from '../assets/icons/delete.png'
import ConfirmationModal from "../reusable_components/ConfirmationModal";
import formatNumberToUs from "../custom_functions/formatNumberToUs";


function ResourceCharges() {
    const [ showAddResource, setShowAddResource ] = useState(false);
    const [ deleteId, setDeleteId ] = useState(null)
    const [ reloadTable, setReloadTable ] = useState(false)

    async function deleteResourceCharge() {
        try {
            const reqUrl = url + '/resource_charge/' + deleteId;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.delete(reqUrl, { headers });
            console.log(data);
            toast.success(data.message, { autoClose: 3000 })
            setReloadTable(1 + Math.random())
        } catch (error) {
            console.log(error)
            toast.error(error?.response?.data?.message || error.message, { autoClose: 3000 })
        } finally {
            setDeleteId(null)
        }
    }

    const options = [
        {
            header: 'Resource Name',
            key: 'name',
        },
        {
            header: 'Charge/Hr',
            render: (data) => {
                return(
                    `$${formatNumberToUs(data.cost?.toFixed(2))}`
                )
            },
            filterKey: 'cost'
        },
        {
            header: 'Action',
            render: (data) => {
                return(
                    <div className="">
                        {/* <button 
                            className={'bg-customOne p-2 rounded-full mr-4'}
                            // onClick={() => toggleModify(data)}
                        >
                            <img src={edit} height={15} width={15} />
                        </button> */}
                        <button 
                            className={'bg-customOne p-2 rounded-full mr-4'}
                            onClick={() => setDeleteId(data.id)}
                        >
                            <img src={deleteIcon} height={15} width={15} />
                        </button>
                    </div>
                )
            }
        }
    ]

    const excludeFilter = ['Action']

    return(
        <div className="p-4">
            {
                showAddResource && <AddResourceCharge setShowModal={setShowAddResource} reload={setReloadTable} />
            }
            {
                deleteId && <ConfirmationModal title={'Resource'} setShowForm={setDeleteId} confirm={deleteResourceCharge} />
            }
            <div className={title}>Resource Charges</div>
            
            <Table 
                options={options} 
                url={url + '/resource_charges'} 
                pagination 
                clickHandler={() => setShowAddResource(!showAddResource)}
                btnTitle={'Resource'}
                excludeFilter={excludeFilter}
                reloadTable={reloadTable}
            />
        </div>
    )
}

export default ResourceCharges;